import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Select, Button, Divider, Space } from 'antd';
import TextLoop from 'react-text-loop';
import store from 'store';
import { ReactComponent as TogetherSvg } from '../../../assets/icons/together.svg';
import useChangeLanguage from '../../../containers/hooks/useChangeLanguage';
import { postPatientAPICall } from '../../../api/patient';
import { LOCAL_STORAGE_AUTH_KEY } from '../../../config/constants';

const { Title } = Typography;

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  title: {
    margin: '35px 0px',
    whiteSpace: 'pre-line',
    fontSize: '20px',
    color: '#262626',
    fontWeight: '400'
  },
  welcomeTitle: {
    margin: '15px 0 25px',
    whiteSpace: 'pre-line',
    fontWeight: '500'
  },
};

function SignInMain() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();
  const { lang, langOptions, changeLanguage } = useChangeLanguage();

  const onChange = (value) => {
    const [language, direction] = value;
    changeLanguage(language, direction);
  };

  const onFirstTime = async () => {
    const guestId = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
    if (guestId === undefined) {
      const { responseOk, responseJSON } = await postPatientAPICall();
      if (responseOk) {
        store.set(LOCAL_STORAGE_AUTH_KEY.GUEST_ID, responseJSON.guid);
        store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE_GUEST, responseJSON)
        history.push('/reason');
      }
    } else {
      history.push('/reason');
    }
  };

  const onReturning = () => {
    history.push('/sign-in-select');
  }

  return (
    <Box position="relative">
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <img
            alt='Logo'
            src={`${window.location.origin  }/alem_health_logo.png`}
            style={{
              objectFit: 'contain',
              margin: 0,
              padding: 0,
              height: 40,
            }}
          />
        </Row>
        <Row type="flex" align="middle" gutter={24} style={{ width: '100%' }}>
          <Col>
            <div className="language-label">
              <TextLoop>
                {langOptions.map(({ value }) => (
                  <Title key={value} level={4} style={styles.welcomeTitle}>
                    {t(`common:language.title.${value}`)}
                  </Title>
                ))}
              </TextLoop>
            </div>
          </Col>
          <Col flex={1}>
            <div>
              <Select
                style={{ width: '90%' }}
                size="large"
                value={t(`common:language.${lang}`)}
                onChange={onChange}
              >
                {langOptions.map(({ value, direction }) => (
                  <Select.Option key={value} value={[value, direction]}>
                    {t(`common:language.${value}`)}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Box display="flex" justifyContent="center">
          <TogetherSvg style={{ margin: '20', maxWidth: '80%' }} />
        </Box>
        <Box textAlign="center">
          <Row gutter={[0, 24]}>
            <Col xs={24}>
              <Title level={4} style={styles.title}>
                {t('welcome:getStarted.title')}<br />
                {t('welcome:getStarted.subtitle')}
              </Title>
              <Divider plain><p style={styles.divider}>Let’s get started</p></Divider>
              <br />
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onFirstTime}
                  block
                  ghost
                >
                  {t('welcome:signIn.firstTime')}
                </Button>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onReturning}
                  block
                >
                  {t('welcome:signIn.returning')}
                </Button>
              </Space>
            </Col>
          </Row>
        </Box>
      </Box>
      <Box height="100px" marginBottom="50px" />
      <Box position="absolute" bottom="50px" marginLeft="auto" marginRight="auto" left="0" right="0" minWidth="320px" paddingX={20}>
        <div style={{ textAlign: 'center'}}>
          <Link to="/privacy" style={styles.privacy}>{t('welcome:signIn.privacy')}</Link>
        </div>
      </Box>
    </Box>
  );
}

export default SignInMain;
